import { render, staticRenderFns } from "./dynamicComponentWrapper.vue?vue&type=template&id=0195741a&"
import script from "./dynamicComponentWrapper.vue?vue&type=script&lang=js&"
export * from "./dynamicComponentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports